var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Logout"},[_c('h1',[_vm._v("Artist Log Out")]),_c('h2',[_vm._v("Logged Out Succesful")]),_c('router-link',{attrs:{"to":"/"}},[_vm._v("\n        Chicago-Artwork\n        "),_c('br'),_vm._v("Home\n      ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }